import { render, staticRenderFns } from "./AbnormalOrderModal.vue?vue&type=template&id=b7516dbc"
import script from "./AbnormalOrderModal.vue?vue&type=script&lang=js"
export * from "./AbnormalOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports